
// app.routes.ts
import { Routes } from '@angular/router';
import { HostRedirectGuard } from '@core/guards/host-redirect.guard'; // ajuste o caminho conforme seu projeto

export const APP_ROUTES: Routes = [

  // Wrapper raiz: TODAS as rotas passam pelo HostRedirectGuard
  {
    path: '',
    canActivate: [HostRedirectGuard],
    // Se o HostRedirectGuard também implementar CanActivateChild, habilitar a linha abaixo:
    canActivateChild: [HostRedirectGuard],

    children: [

      // Rotas Liberadas, proteger rotas nos módulos conforme necessário
      /* ************************************************************************************************************************* */
      {
        path: 'not-found',
        loadChildren: () => import('./modules/main-not-found/main-not-found.routes').then((m) => m.MAIN_NOT_FOUND_ROUTES),
      },
      {
        path: '404',
        loadChildren: () => import('./modules/main-not-found/main-not-found.routes').then((m) => m.MAIN_NOT_FOUND_ROUTES),
      },
      {
        path: 'login',
        loadChildren: () => import('./modules/auth-login/auth-login.routes').then((m) => m.AUTH_LOGIN_ROUTES),
      },
      {
        path: 'checkout',
        loadChildren: () => import('./modules/checkout/checkout.routes').then((m) => m.CHECKOUT_ROUTES),
      },
      {
        path: 'i',
        //pathMatch: 'full',
        loadChildren: () => import('./modules/iorthopay/iorthopay.routes').then(m => m.IORTHOPAY_ROUTES),
      },

      {
        path: 'home',
        loadChildren: () => import('./modules/main-home/main-home.routes').then(m => m.MAIN_HOME_ROUTES),
      },
      {
        path: 'settings',
        pathMatch: 'full',
        //canActivate: [CanActivateRouteGuard], // proteger rotas nos módulos conforme necessário
        loadChildren: () => import('./modules/admin/admin.routes').then(m => m.ADMIN_ROUTES),
      },
      {
        path: '**',
        redirectTo: 'home',
      }
      /* ************************************************************************************************************************* */



    ],
  },

];
